<template>
    <div class='col col--12' style='height: calc(100% - 50px);'>
        <div class='w-full relative' :class='{
            mapFull: !$route.params.station,
            mapHalf: $route.params.station
        }'>
            <div id="map" class='w-full h-full'></div>

            <div class='absolute top right z2 bg-white round mx12 my12 px6 py3'>
                <span class='fl py3 mr6'><svg class='icon'><use xlink:href='#icon-search'/></svg></span>Zoom in to see all stations
            </div>
        </div>

        <template v-if='$route.params.station'>
            <div class='grid col col--12 px12 py12 relative'>
                <div class='col col--12 bg-transparent'>
                    <div class='col col--12 flex-parent flex-parent--center-main bg-transparent absolute' style='top: -24px;'>
                        <button @click='$router.push("/")' class='flex-child btn btn--s btn--stroke round-t px6 btn--white'><svg class='fl icon' style="margin-top: 4px"><use xlink:href='#icon-arrow-down'/></svg> Close</button>
                    </div>
                </div>
                <div class='grid col col--12 pb6 border-b border--gray-light'>
                    <div class='col col--3'>
                        <div class='w-full'>Forecast Revision</div>
                        <div v-if='revs.length' class='select-container'>
                            <select v-model='rev' class='select select--s'>
                                <option :key='rev' v-for='rev in revs' :value='rev'><span v-text='rev'/></option>
                            </select>
                            <div class='select-arrow'></div>
                        </div>
                    </div>
                    <div class='col col--6'>
                        <div class='w-full align-center'>
                            <span class='txt-h4' v-text='"Station #" + $route.params.station'/>
                        </div>
                        <div class='w-full align-center'>
                            <span class='txt--s' v-text='station.properties.name'/>
                        </div>
                    </div>
                    <div class='col col--3'>
                        <div class='w-full clearfix'><span class='fr'>Export Forecast</span></div>
                        <button @click='dl' class='fr btn btn--s round btn--stroke h24 color-gray color-green-on-hover'>
                            <svg class='icon'><use xlink:href='#icon-arrow-down'/></svg>
                        </button>
                        <div class='select-container fr mr3'>
                            <select v-model='format' class='select select--s'>
                                <option>csv</option>
                                <option>json</option>
                                <option>jsonld</option>
                            </select>
                            <div class='select-arrow'></div>
                        </div>
                    </div>
                </div>
                <div class='col col--12'>
                    <template v-if='loading.station'>
                        <div class="loading pt60"></div>
                        <div class='align-center'>Loading Station...</div>
                    </template>
                    <template v-else>
                        <LineChart v-if='forecast.gas' class='w-full' style='height: 200px' :chartData='forecast.gas' options='{
                            "maintainAspectRatio": false,
                            "scales": {
                                "xAxes": [{
                                    "type": "time",
                                    "time": { "unit": "day" },
                                    "distribution": "linear"
                                }],
                                "yAxes": [{ "ticks": { "beginAtZero": true } }]
                            }
                        }'/>

                        <LineChart v-if='forecast.temp' class='w-full' style='height: 200px' :chartData='forecast.temp' options='{
                            "maintainAspectRatio": false,
                            "scales": {
                                "xAxes": [{
                                    "type": "time",
                                    "time": { "unit": "day" },
                                    "distribution": "linear"
                                }],
                                "yAxes": [{ "ticks": { "beginAtZero": true } }]
                            }
                        }'/>

                        <LineChart v-if='forecast.precip' class='w-full' style='height: 200px' :chartData='forecast.precip' options='{
                            "maintainAspectRatio": false,
                            "scales": {
                                "xAxes": [{
                                    "type": "time",
                                    "time": { "unit": "day" },
                                    "distribution": "linear"
                                }],
                                "yAxes": [{ "ticks": { "beginAtZero": true } }]
                            }
                        }'/>

                        <LineChart v-if='forecast.pressure' class='w-full' style='height: 200px' :chartData='forecast.pressure' options='{
                            "maintainAspectRatio": false,
                            "scales": {
                                "xAxes": [{
                                    "type": "time",
                                    "time": { "unit": "day" },
                                    "distribution": "linear"
                                }],
                                "yAxes": [{ "ticks": { "beginAtZero": true } }]
                            }
                        }'/>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import LineChart from './LineChart.js';

export default {
    name: 'Map',
    props: ['meta'],
    data: function() {
        return {
            map: false,
            token: false,
            rev: '',
            revs: [],
            format: 'csv',
            forecast: {
                temp: false
            },
            station: {
                properties: {
                    name: ''
                }
            },
            loading: {
                station: false
            }
        };
    },
    watch: {
        rev: function() {
            this.init_station(true);
        },
        $route: function() {
            this.init_station();
        }
    },
    mounted: function() {
        this.init();
        this.init_station();
    },
    methods: {
        init_station: async function(rev_change) {
            if (!this.$route.params.station) return;

            this.loading.station = true;

            await this.getStation();
            if (!rev_change) {
                this.revs = [];
                await this.getStationRevs();
            }

            await this.getStationForecast();
            this.loading.station = false;
        },
        dl: function() {
            this.external(window.location.origin + `/api/station/${this.$route.params.station}/forecast?format=${this.format}&dl=true&revision=${encodeURIComponent(this.rev)}`);
        },
        init: function() {
            mapboxgl.accessToken = this.meta.token;

            this.map = new mapboxgl.Map({
                container: 'map',
                zoom: 1,
                style: 'mapbox://styles/mapbox/satellite-streets-v11'
            });

            this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

            this.map.on('load', () => {
                this.map.addSource('stations', {
                    type: 'vector',
                    tiles: [ `${window.location.origin}/api/tiles/{z}/{x}/{y}.mvt` ],
                    minzoom: 0,
                    maxzoom: 16
                });

                this.map.on('click', 'stations', (e) => {
                    if (e.features.length === 0) return;

                    if (String(this.$route.params.station) !== String(e.features[0].properties.id)) {
                        this.$router.push(`/station/${e.features[0].properties.id}`);
                    }
                });

                this.map.addLayer({
                    id: 'stations',
                    type: 'circle',
                    source: 'stations',
                    'source-layer': 'data',
                    layout: { },
                    paint: {
                        'circle-color': '#ff0000',
                        'circle-radius': 5,
                        'circle-opacity': 1.0,
                        'circle-stroke-color': '#ffffff',
                        'circle-stroke-width': 1
                    }
                });

                this.map.on('mousemove', 'stations', () => {
                    this.map.getCanvas().style.cursor = 'pointer';
                });

                this.map.on('mouseleave', 'stations', () => {
                    this.map.getCanvas().style.cursor = '';
                });
            });
        },
        getStation() {
            fetch(window.location.origin + `/api/station/${this.$route.params.station}`, {
                method: 'GET'
            }).then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to get station') ;
                }

                return res.json();
            }).then((res) => {
                this.station = res;
            });
        },
        getStationForecast() {
            fetch(window.location.origin + `/api/station/${this.$route.params.station}/forecast?format=json&revision=${encodeURIComponent(this.rev)}`, {
                method: 'GET'
            }).then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to get station forecast') ;
                }

                return res.json();
            }).then((res) => {
                this.forecast.temp = {
                    datasets: [{
                        label: 'Temperature (K)',
                        data: res.map((d) => { return { x: d.date, y: d.temp }; })
                    }]
                };

                this.forecast.precip = {
                    datasets: [{
                        label: 'Precipitation (mm)',
                        data: res.map((d) => { return { x: d.date, y: d.precip }; })
                    }]
                };

                this.forecast.pressure = {
                    datasets: [{
                        label: 'Pressure (hPa)',
                        data: res.map((d) => { return { x: d.date, y: d.pressure }; })
                    }]
                };

                this.forecast.gas = {
                    datasets: [{
                        label: 'O3 (ugm-3)',
                        backgroundColor: '#9400D3',
                        data: res.map((d) => { return { x: d.date, y: d.gas.o3 }; })
                    },{
                        label: 'NO2 (ugm-3)',
                        backgroundColor: '#228B22',
                        data: res.map((d) => { return { x: d.date, y: d.gas.no2 }; })
                    },{
                        label: 'PM25 gcc (ugm-3)',
                        backgroundColor: '#FF4500',
                        data: res.map((d) => { return { x: d.date, y: d.gas.pm25_gcc }; })
                    },{
                        label: 'PM25 gocart (ugm-3)',
                        backgroundColor: '#FF4500',
                        data: res.map((d) => { return { x: d.date, y: d.gas.pm25_gocart }; })
                    }]
                };
            });
        },
        getStationRevs() {
            fetch(window.location.origin + `/api/station/${this.$route.params.station}/revisions`, {
                method: 'GET'
            }).then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to get station revisions') ;
                }

                return res.json();
            }).then((res) => {
                this.revs =  res.revisions;
                this.rev = this.revs[0];
            });
        },
        external: function(url, tab) {
            if (!tab) {
                window.location.href = url;
            } else {
                window.open(url, "_blank");
            }
        },

    },
    components: {
        LineChart
    }
}
</script>

<style>
.mapFull {
    height: 100%;
}

.mapHalf {
    height: 50%;
}
</style>
